import { useEffect, useState } from "react";
import ButtonCustom from "./ButtonCustom";
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from "@material-ui/core";
import { CheckIcon, DeleteWhiteIcon, FACIcon, PaypalIcon } from "./icons";
import CustomizedCircularProgress from "./CircularProgress";
import crmservices from "../wsclient/crmservices";
import { getContacts, setPaymentRecuring } from "../utils/common";
import CustomTypo from "./CustomTypo";
import { connection, domainName } from "../../portal.config";
import AddCard from '../pages/order-cards/AddCard';

// accountt 
// sb-zohys7237983@business.example.com
// M;SB31?x
// EJ37VS8BQHJVA
// sb-2vtnz7239030@personal.example.com
// 0pB{^r7P
// RB7JN2DTVU566
// sb-xtymq7240364@personal.example.com
// 2Oasr!Sz
// 5Z3ABHFRWGEMY

function FAC(props) {
	const [clientToken, setClientToken] = useState(null);
	const [showLoading, onShowLoading] = useState(false);
	const [facs, setFACs] = useState(undefined);
	const [openAddCard, setOpenAddCard] = useState(undefined);
	const [htmlContent, setHtmlContent] = useState(undefined);

	const contact = getContacts();
	const { classes, t } = props;
	
	const getClientToken = async () => {
		onShowLoading(true);
		try {
			let facIntegrationId = connection.crmConfig.facIntegration;
			let result = await crmservices.paymentgateway.getClientToken({ integration_id: facIntegrationId });
			console.log('getClientToken result===', result)
			if (result && result.code == 'OK' && result.data && result.data.client_token) {
				let clientToken = result.data.client_token;
				// window.location.href = document._portalConfig.urlFACPayOnline + "/" + clientToken;
				let redirectData = atob(clientToken);
				console.log("redirectData result: ", redirectData);
				// setOpenAddCard(true);
				setHtmlContent(redirectData);
				setPaymentRecuring({
					is_recurring: true,
				});
				document.write(redirectData)
			}
		}
		catch (e) {
			onShowLoading(false)
			console.log('getClientToken error: ', e)
		}

		onShowLoading(false)
	}

	let _facs = facs ? facs : props.facs;
	return (
		<Grid item container justify='center' className={classes.container}>
			{/* <Grid item xs={12}>
				<CustomTypo mg_left_sm variant='caption1' color='onPrimary'>{'Your FAC'}</CustomTypo>
			</Grid> */}
			<Grid item xs={12}>
				{showLoading && <CustomizedCircularProgress />}
			</Grid>
			{_facs.length > 0 && _facs.map((item, index) => <CardItem item={item} classes={classes} setPrimaryCard={props.setPrimaryCard} onRemoveCard={props.onRemoveCard} />)}
			<Grid xs={12} item className={classes.button_add} container justify='center'>
				<div id="paypal-button"></div>
			</Grid>
			<ButtonCustom fullWidth={true} onClick={() => getClientToken()} color="primary">{"Add Card with FAC"}</ButtonCustom>
			{openAddCard && <AddCard
                open = {openAddCard}
				form_id="powertranz_spi"
				isOverwriteDocument={true}
                onClose = {() => setOpenAddCard(false)} 
                html_add_card_content = {htmlContent}   />}
		</Grid>
	)
}
function CardItem(props){
    const {classes,item} = props
    //console.log('CardItem=== ',item)
    let card_holder_name = item.card&&item.card.card_holder_details&&item.card.card_holder_details.card_holder_name?item.card.card_holder_details.card_holder_name:""
    return(
        <Grid xs={12} item container className={classes.method_container}>
            <Grid xs={11} item className={classes.method_pre}>
                <Grid  item className={classes.method} container alignItems='center' onClick={() => props.setPrimaryCard(item.id)}>
                    <Grid xs={2} item container justify='flex-start'>
						<FACIcon  style={{width:80,height:40,objectFit:'contain'}}/>
                    </Grid>
                    <Grid xs={8} item>
                        <CustomTypo mg_left_sm variant='body1'>{item && item.card && item.card.last4 ? "**** **** **** " + item.card.last4 : ""}</CustomTypo>
                    </Grid>
                    {item.is_primary && <Grid xs={2}  item container justify='flex-end' >
                        <CheckIcon/>
                    </Grid>}
                </Grid>
            </Grid>
                <Grid xs={1} item container justify='flex-end' alignItems='center'>
                    <div className={classes.bg_icon} onClick={() => props.onRemoveCard(item)}>
                        <DeleteWhiteIcon />
                    </div>
                </Grid>
        </Grid>
    )
}
const styles = theme => ({
	container: {
		marginTop: theme.spacing(8)
	},
	method_container: {
		padding: theme.spacing(4, 0, 0, 0)
	},
	method_pre: {
		padding: theme.spacing(0, 2, 0, 0)
	},
	method: {
		backgroundColor: theme.palette.background.secondary,
		borderRadius: theme.spacing(2),
		// height: theme.spacing(12),
		padding: theme.spacing(1, 4, 1, 4),
		cursor: 'pointer',
		[theme.breakpoints.down('xs')]: {
			padding: theme.spacing(1, 2, 1, 2),
		}
	},
	button_add: {
		marginTop: theme.spacing(10)
	},
	bg_icon: {
		width: theme.spacing(6),
		height: theme.spacing(6),
		borderRadius: theme.spacing(6),
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: theme.palette.icon.trash,
		cursor: "pointer",
		touchAction: "manipulation",
	}
});
export default withStyles(styles)(withTranslation()(FAC));